import { apiHelper } from '@/utils'
import { API, SHARED } from '@/constants'

export const domainService = {
    getAllDomains,
    getDomain,
    createDomain,
    updateDomain,
    updateDomainStatus,
    checkDomain,
    getDomainResults,
  getPlayerReports,
  };

const MODULE = {
    DOMAIN: 'domains',
}

const API_URL = API.BASE_URL + '/v1'


export function getAllDomains(filter) {

    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
      }
    }

    if (filter.isActive != null && filter.isActive !== SHARED.DEFAULT_ALL_VALUE) {
      requestOptions.params.is_active = filter.isActive
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })

    return apiHelper(API_URL).get(`/${MODULE.DOMAIN}`, requestOptions)
}

export function getDomain(uuid) {
  return apiHelper(API_URL).get(`/${MODULE.DOMAIN}/${uuid}`)
}

export function createDomain(data) {
  const requestOptions = {
    domain: data.domain,
    country_code: data.countryCode,
    remark: data.remark,
    domain_group_uuid: data.domainGroupUuid || null
  }

  return apiHelper(API_URL).post(`/${MODULE.DOMAIN}`, requestOptions)
}

export function updateDomain(uuid, data) {
  const requestOptions = {
    domain: data.domain,
    country_code: data.countryCode,
    remark: data.remark,
    domain_group_uuid: data.domainGroupUuid || null
  }

  return apiHelper(API_URL).put(`/${MODULE.DOMAIN}/${uuid}`, requestOptions)
}

export function updateDomainStatus(data) {
  const requestOptions = {
    is_active: data.isActive ? 1 : 0
  }

  return apiHelper(API_URL).patch(`/${MODULE.DOMAIN}/${data.uuid}/status`, requestOptions)
}

export function checkDomain(uuid) {
  return apiHelper(API_URL).post(`/${MODULE.DOMAIN}/${uuid}/check`)
}

export function getDomainResults(uuid, filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
    }
  }

  return apiHelper(API_URL).get(`/${MODULE.DOMAIN}/${uuid}/results`, requestOptions)
}

export function getPlayerReports(uuid, filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
    }
  }

  if (filter.opened != null && filter.opened !== '') {
    requestOptions.params.opened = filter.opened ? 1 : 0
  }

  if (filter.hours) {
    requestOptions.params.hours = filter.hours
  }

  return apiHelper(API_URL).get(`/${MODULE.DOMAIN}/${uuid}/player-reports`, requestOptions)
}
